import { FC, useMemo } from 'react'
import styles from 'components/features/external/PublicSpendingTrend/LineChartSections.styl'
import { PublicTrendItem } from 'interfaces/publicDashboard'
import cn from 'classnames'
import moment from 'moment'
import { CHART_LABELS_TILT_THRESHOLD } from 'constants/component'

type LineChartSectionsProps = {
  items: PublicTrendItem[]
  isPreliminary?: boolean
  index: number
  width: number
}

export const LineChartSections: FC<LineChartSectionsProps> = (props) => {
  const { items, index, width, isPreliminary } = props

  const { shouldRotate, dimBy, offset } = useMemo(() => {
    const length = items.length
    const sectionWidth = width / items.length

    let dimByLocal = 1
    if (sectionWidth < 10) {
      dimByLocal = 4
    } else if (sectionWidth < 25) {
      dimByLocal = 2
    }

    const offsetLocal = length - Math.floor(length / dimByLocal) * dimByLocal - 1

    return {
      shouldRotate: sectionWidth < CHART_LABELS_TILT_THRESHOLD,
      dimBy: dimByLocal,
      offset: offsetLocal,
    }
  }, [width, items])

  return (
    <div className={ cn(styles.lineChartSections, shouldRotate && styles.rotate) }>
      { items.map((item, itemIndex) => (
        <div
          className={ cn(styles.section, itemIndex === index && styles.highlight) }
          key={ itemIndex }
        >
          { ((itemIndex - offset) % dimBy) === 0 &&
            <div className={ styles.text }>
              { moment(item.date).format('MMM D') }
              { (itemIndex === items.length - 1) && isPreliminary && (
                <>&nbsp;(p)</>
              )}
            </div>}
        </div>
      ))}
    </div>
  )
}
